import { defineComponent as _defineComponent } from 'vue'
import { Button } from 'ui-shared-components';
import { AdditionalTravellersCombinedProductSummary } from 'ecommerce/feature-additional-travellers-combined-products';
//types
import type { LoungePassTraveller, TravelInsuranceTraveller } from '../../../types';

interface Props {
  travelInsuranceTravellers?: TravelInsuranceTraveller[];
  loungePassTravellers?: LoungePassTraveller[];
  isEditDetailsCtaDisabled?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'update-additional-travellers-combined-products-list',
  props: {
    travelInsuranceTravellers: { default: () => [] },
    loungePassTravellers: { default: () => [] },
    isEditDetailsCtaDisabled: { type: Boolean, default: false }
  },
  emits: ["update-traveller-details"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update-traveller-details'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { travelInsuranceTravellers: TravelInsuranceTraveller[], loungePassTravellers: LoungePassTraveller[], isEditDetailsCtaDisabled: boolean };

//components




return { __sfc: true,emit, props, Button, AdditionalTravellersCombinedProductSummary }
}

})